/* eslint-disable react/jsx-key */
/* eslint-disable camelcase */
import React from 'react'
import { Box, Text, Skeleton, SimpleGrid, HStack } from '@chakra-ui/react'
import Order from './Order'

const Orders = ({
  loading,
  orders,
  onOrderComplete,
  onOrderEdit,
  onOrderNotify,
  onOrderDrinksStart,
  locations,
  ordersLoading,
  showCompletedOrders,
  menu,
}: any) => {
  const getTheme = (order: any) => {
    if (order.type != 'reservation') {
      return 'darkTeal'
    }

    if (order.items?.length === 0) {
      return 'darkBlue'
    }

    return 'darkOrange'
  }

  if (ordersLoading) {
    return (
      <Box w='full' pl={{ base: 0, md: 48 }}>
        <SimpleGrid
          gap={{ base: 10, md: 4 }}
          px={4}
          w='full'
          mt={4}
          columns={{ base: 1, md: 1, lg: 4 }}
        >
          <Skeleton height='500px' />
          <Skeleton height='500px' />
          <Skeleton height='500px' />
          <Skeleton height='500px' />
        </SimpleGrid>
      </Box>
    )
  }

  if (!orders || orders.length === 0) {
    return (
      <Box w='full' pl={{ base: 0, md: 48 }}>
        <HStack
          minHeight='100vh'
          justifyContent='center'
          alignItems='center'
          fontSize={40}
          fontWeight='b2old'
        >
          <Text>No orders</Text>
        </HStack>
      </Box>
    )
  }

  return (
    <Box w='full' pl={{ base: 0, md: 48 }}>
      <SimpleGrid
        gap={{ base: 10, md: 4 }}
        px={4}
        w='full'
        mt={2}
        columns={{ base: 1, md: 2, lg: 3, xl: 4 }}
      >
        {orders &&
          orders.map((order: any) => {
            if (!showCompletedOrders && order.status === 'completed') {
              return
            }

            return (
              <Order
                key={order.id}
                loading={loading}
                order={order}
                theme={getTheme(order)}
                onOrderComplete={onOrderComplete}
                onOrderEdit={onOrderEdit}
                onOrderNotify={onOrderNotify}
                onOrderDrinksStart={onOrderDrinksStart}
                locations={locations}
                menu={menu}
              />
            )
          })}
      </SimpleGrid>
    </Box>
  )
}

export default Orders
